import { render, staticRenderFns } from "./TierDataTable.vue?vue&type=template&id=5663f24c&"
import script from "./TierDataTable.vue?vue&type=script&lang=js&"
export * from "./TierDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VDataTable,VPagination})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5663f24c')) {
      api.createRecord('5663f24c', component.options)
    } else {
      api.reload('5663f24c', component.options)
    }
    module.hot.accept("./TierDataTable.vue?vue&type=template&id=5663f24c&", function () {
      api.rerender('5663f24c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Agent/components/Tier/TierDataTable.vue"
export default component.exports